import React from 'react';
// import Dialog from 'material-ui/Dialog';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import FlatButton from 'material-ui/FlatButton';
import Button from "components/CustomButtons/Button.jsx";
import DialogActions from "@material-ui/core/DialogActions";

const styles = {
    button: {
        fontFamily: 'Poppins'
    }
}
/**
 * The dialog width has been set to occupy the full width of browser through the `contentStyle` property.
 */
export default class DialogExampleCustomWidth extends React.Component {
    state = {
        open: false,
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { modalStatus, handleClose, content, title, modalActionLabel, handleModalAction, isAddPassengerModal } = this.props;
        const actions = [
            <FlatButton
                label="Dismiss"
                primary={false}
                onClick={handleClose}
                style={styles.button}
            />
        ];

        if (handleModalAction) {
            actions.unshift(
                <Button color={'primary'} onClick={() => handleModalAction()}>
                    {(modalActionLabel) ? modalActionLabel : 'Proceed'}
                </Button>
            )
        }

        return (
            <div>
                {/*<RaisedButton label="Dialog With Custom Width" onClick={this.handleOpen} />*/}
                <Dialog
                    fullWidth={true}
                    maxWidth={'md'}
                    aria-labelledby="responsive-dialog-title"
                    // contentStyle={modalStyle}
                    title={title}
                    // actions={actions}
                    // modal={modalStatus}
                    open={modalStatus}
                >
                    <DialogContent>
                        {content}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="danger">
                            DISMISS
                        </Button>
                        {isAddPassengerModal ? modalActionLabel : (modalActionLabel) ?
                            <Button onClick={() => handleModalAction()} color={'primary'} autoFocus>
                                {modalActionLabel}
                            </Button> : "" }
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/utils/Modal.js